import React from "react";
import { useTranslation } from "react-i18next";
import SocialLinks from "../SocialLinks";
import "./Footer.css";

function Footer() {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="bg-navy text-white-50 py-4 border-top border-navy-light">
      <div className="container">
        <div className="row justify-content-center pb-3 mb-3 border-bottom border-navy-light">
          <div className="col-auto">
            <SocialLinks />
          </div>
        </div>
        <div className="row align-items-center gy-3">
          <div className="col-md-5 text-center text-md-start small">
            <span className="text-white fw-semibold">{t('footer.officeName')}</span>
            <span className="mx-2">·</span>
            <span>{t('footer.disclaimer')}</span>
          </div>
          <div className="col-md-2 text-center small">
            <div className="imgCont">
              <img src="/Images/FullLogo.png" alt={t('footer.officeName')} />
            </div>
          </div>
          <div className="col-md-5 text-center text-md-end small">
            {t('footer.copyright', { year })}
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
